import {
    NewsletterFormValues,
    NewsletterRequest,
    ProfileRequest,
} from 'models/User';
import useUserSWR from '../../hooks/user/useUserSWR';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import useFullScreenLoading from 'hooks/useFullScreenLoading';
import useUser from 'hooks/user/useUser';
import useDefaultStockSWR from 'hooks/useDefaultStock';
import SnackbarUtils from 'utils/SnackbarUtils';

export const NewsletterSignup = () => {
    const { user, isLoading, isError, forceRefresh } = useUserSWR();
    const { t } = useTranslation('profile');
    const { t: tCustom } = useTranslation('translation', {
        keyPrefix: 'NOTIFICATION',
    });
    const useProfile = useUser();
    const fullScreenLoading = useFullScreenLoading();

    const [submitIsLoading, setSubmitIsLoading] = useState(false);

    const makeRequestBody = (data): NewsletterRequest => {
        return {
            first_name: user.first_name,
            last_name: user.last_name,
            company: user.company,
            phone: user.phone,
            tax_number: user.tax_number,
            default_stock: user.default_stock,
            default_profit_margin: user.default_profit_margin,
            accepts_marketing: true,
        };
    };

    const handleNewsletterSubscribe = (data: NewsletterFormValues) => {
        if (user.accepts_marketing) {
            SnackbarUtils.error(
                tCustom('NEWSLETTER_ALREADY_SUBSCRIBED').toString()
            );
        } else {
            setSubmitIsLoading(true);
            fullScreenLoading.setFullScreenLoading(true);
            useProfile
                .updateUser(makeRequestBody(data))
                .then(() => {
                    SnackbarUtils.success(
                        tCustom('NEWSLETTER_SUBSCRIPTION_SUCCESS').toString()
                    );
                    forceRefresh();
                })
                .catch(() => {
                    SnackbarUtils.error(
                        tCustom('NEWSLETTER_SUBSCRIPTION_FAILURE').toString()
                    );
                    setSubmitIsLoading(false);
                })
                .finally(() => {
                    setSubmitIsLoading(false);
                    fullScreenLoading.setFullScreenLoading(false);
                });
        }
    };

    return (
        <Box>
            <Box sx={{ paddingBottom: '10px' }}>
                <Typography variant="h2">
                    {t('PROFILE.NEWSLETTER.TITLE')}
                </Typography>
            </Box>
            {!isLoading && !isError && (
                <>
                    <Box>{t('PROFILE.NEWSLETTER.DESCRIPTION')}</Box>
                    <Box sx={{ paddingTop: '10px' }}>
                        <PrimaryBtn
                            onClick={handleNewsletterSubscribe}
                            disabled={submitIsLoading}
                        >
                            {t('PROFILE.NEWSLETTER.SIGNUP')}
                        </PrimaryBtn>
                    </Box>
                </>
            )}
        </Box>
    );
};
